/**
 * Created by desheng.zhao on 2019/6/18.
 */
const wechat = {
  state: {
    iswechat: ""
  },
  mutations: {
    wechat(state, payload) {
      state.iswechat = payload
    }
  },
  actions: {
    wechat(state, payload) {
      state.commit("wechat",payload)
    }
  },
  getters: {
    wechat: function(state){
      return state.iswechat;
    }
  }
}

export default wechat;


// WEBPACK FOOTER //
// ./src/store/wechat.js